import React, { useCallback } from "react";
import { Container } from "react-bootstrap";
import { gtIframeUser } from "../Redux/usersReduce";
import { useDispatch } from "react-redux";

function DashBoard(obj) {
  const dispatch = useDispatch();
  const [iframe, setIframe] = React.useState(null);

  const getIframe = useCallback(async (id_line) => {
    try {
      dispatch(gtIframeUser({id_line})).then(e => {
        setIframe(e.payload.iframe)
      })
    } catch (error) {
      console.log(error)
    }

  }, [dispatch]);

  React.useEffect(() => {
    console.log(obj.obj.user)
    getIframe(obj.obj.user.id_line)
  }, [iframe]);

  return (
    <>
      <Container fluid>
        <iframe width="100%" height="800px" src={iframe}></iframe>
      </Container>
    </>
  );
}

export default DashBoard;
